<template>
  <div class="container mx-auto my-3 mt-sm-5">
    <div class="row my-auto">
      <div class="col-md-8 col-12 mx-auto">
        <div class="card border-0 shadow py-sm-5">
          <div class="row">
            <div
              class="col-md-10 col-12 mx-auto"
              style="min-height: 720px"
            >
              <div
                v-if="isReady"
                class="card-body"
                style="transition: all 1s"
              >
                <h4
                  class="card-title font-weight-bold mb-sm-5 d-flex
                  flex-column flex-sm-row justify-content-sm-between
                  justify-content-around"
                >
                  <div
                    class="order-2 order-sm-1 mt-sm-0 mt-3 text-center"
                  >
                    Contrat
                    <v-highlight :color="color">
                      {{ status }}
                    </v-highlight>
                  </div>
                  <div class="order-1 order-sm-2 text-center">
                    <v-icon
                      :icon="icon"
                      height="40"
                      width="40"
                    />
                  </div>
                </h4>
                <div class="d-sm-none d-flex mx-auto">
                  <div
                    class="btn btn-block mx-auto py-2 text-dark"
                    type="button"
                    @click="open = !open"
                  >
                    En savoir
                    <font-awesome-icon
                      class="ml-2"
                      :icon="open ? 'minus' : 'plus'"
                    />
                  </div>
                </div>
                <transition name="slide">
                  <div
                    v-show="open"
                    class="d-sm-flex flex-column mx-auto"
                    :class="{ hidden: !open }"
                    style="transition: all 1s"
                  >
                    <div
                      v-for="(field, index) in displayedFields"
                      :key="index"
                      class="d-flex flex-row justify-content-between my-2"
                    >
                      <div class="d-flex h6">
                        {{ field.title }}
                      </div>
                      <div
                        class="d-flex text-end"
                        :class="field.color || 'text-gray-600'"
                      >
                        {{ field.value }}
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
              <v-loading-animation v-else />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { toPairs } from 'lodash-es';

import Strings from '@/utils/_Strings';

import Icon from '@/components/common/helpers/Icon.vue';
import LoadingAnimation from '@/components/common/helpers/LoadingAnimation.vue';

export default {
  components: {
    'v-icon': Icon,
    'v-loading-animation': LoadingAnimation,
  },
  data() {
    return {
      open: false,
      isReady: false,
      subscription: {
        reference: null,
        productName: null,
        effectiveDate: null,
        echeance: null,
        status: null,
        period: null,
        liability: null,
        companyName: null,
        companySiret: null,
        subscriberFullName: null,
        cancellationDate: null,
      },
      fields: {
        status: 'Statut',
        reference: 'Référence du contrat',
        echeance: 'Échéance',
        productName: 'Nom du contrat',
        liability: 'Montant de garantie',
        period: 'Période de garantie',
        companyName: 'Nom de l\'entreprise',
        companySiret: 'SIRET',
        subscriberFullName: 'Nom du client',
        cancellationDate: 'Date de résiliation du contrat',
        effectiveDate: 'Date d\'effet',
      },
    };
  },
  computed: {
    displayedFields() {
      return toPairs(this.subscription)
        .map(this.toDisplay)
        .filter(({ value }) => value);
    },
    icon() {
      const icons = {
        CANCELLED: 'times',
        SUSPENDED: 'warning',
        ACTIVE: 'checkmark-green-600',
      };
      return icons[this.subscription.status] || 'times-red';
    },
    status() {
      const status = {
        SUSPENDED: 'suspendu',
        CANCELLED: 'résilié',
        ACTIVE: 'en cours de validité',
      };
      return status[this.subscription.status] || 'non reconnu';
    },
    color() {
      const colors = {
        SUSPENDED: 'warning',
        CANCELLED: 'danger',
        ACTIVE: 'green-600',
      };
      return colors[this.subscription.status] || 'danger';
    },
  },
  mounted() {
    this.$store.dispatch('qrcode/verify', this.$route.params.id)
      .then((subscription) => {
        Object.assign(this.subscription, { ...subscription });
        this.isReady = true;
      });
  },
  methods: {
    toDisplay([key, value]) {
      const title = this.fields[key];
      if (!title) { return {} }
      const field = { value, title, color: 'gray-600' };

      if (key === 'status') {
        Object.assign(field, {
          value: Strings.capitalize(this.status),
          color: `text-${this.color} font-weight-bold`,
        });
      } else if (key === 'reference' && value) {
        Object.assign(field, { value: `n° ${value}` });
      } else if (key === 'period' && value) {
        Object.assign(field, { value: `${value.startDate} au ${value.endDate}` });
      } else if (key === 'companySiret' && value) {
        Object.assign(field, { value: `${value.slice(0, 3)} ${value.slice(3, 6)} ${value.slice(6, 9)} ${value.slice(9)}` });
      }
      return field;
    },
  },
};
</script>
<style scoped>
@media screen and (max-width:576px){
  .hidden {
    height: 0!important;
    overflow: hidden;
  }
}
</style>
